import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './utils/bootstrap.js'; // Initialize Bootstrap JavaScript
import './index.css';
import App from './App';
import 'handsontable/dist/handsontable.full.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { registerAllModules } from 'handsontable/registry';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './react-redux/Store/Store';
import { startVersionCheck } from "./utils/version-checker";
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/Assets/ErrorBoundary';

// Load auth debug utilities in development
if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_DOMAIN_URL === 'https://localhost:3000') {
  import('./utils/authDebug');
}

startVersionCheck(30000);



registerAllModules();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
